/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for PartyResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { PartyType, GetPartiesResponse } from "../models";

@Injectable({ providedIn: "root" })
export class PartyResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getParties(types: Signal<(Array<PartyType> | null) | undefined> | (Array<PartyType> | null) | undefined, resourceOptions: HttpResourceOptions<GetPartiesResponse, unknown> & { defaultValue: NoInfer<GetPartiesResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPartiesResponse>;
    getParties(types?: Signal<(Array<PartyType> | null) | undefined> | (Array<PartyType> | null), resourceOptions?: HttpResourceOptions<GetPartiesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPartiesResponse | undefined>;
    getParties(types?: Signal<(Array<PartyType> | null) | undefined> | (Array<PartyType> | null), resourceOptions?: HttpResourceOptions<GetPartiesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPartiesResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const typesValue = typeof types === 'function' ? types() : types;
            if (typesValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, typesValue, 'types');
            }
            return {
                url: `${this.basePath}/Party`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
